import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';

class offeringListApi {  
    static getOfferingList() {
        let isError = false;
        try{
            let body = {
                method: 'GET',
            }
            return fetch( BASE_URL + `/securityinfo/offerings/active`, body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default offeringListApi;